import React, {
  ReactElement,
} from 'react';
import { Popover } from 'react-tiny-popover';

import * as S from './styled';

type Position = 'top' | 'right' | 'bottom' | 'left';
interface Props {
  /**
   * Contents to render in popup
   */
  children: React.ReactNode,
  /**
   * Custom trigger
   */
  trigger?: ReactElement<any>;
  isOpen: boolean,
  className?: string,
  positions?: Position[];
  setPopupVisible: { (ev: Event): void },
  onClickOutside: { (): void },
}

/**
 * Basic popup
 * @version 1.0.0
 * @author [Ubayd Rahmonzoda](ubayd.rahmonzoda@gmail.com)
 */
const Popup = ({
  isOpen,
  trigger,
  children,
  className,
  positions = ['bottom'],
  setPopupVisible,
  onClickOutside,
}: Props) => (
  <Popover
    content={children}
    isOpen={isOpen}
    positions={positions}
    containerClassName={className}
    onClickOutside={onClickOutside}
  >
    {trigger ? React.cloneElement(
      trigger,
      {
        isOpen,
        onMouseDown: setPopupVisible,
      },
    ) : (
      <S.Trigger
        isOpen={isOpen}
        onMouseDown={setPopupVisible}
      />
    )}
  </Popover>
);

export default Popup;
